import { intl } from '@beelday/common'
import styled from '@emotion/styled'
import {
	Action,
	Card,
	CardLabel,
	CardText,
	CardTitle,
	Eyebrow,
	Screen,
} from './primitives'

const Actions = styled.div`
	display: flex;
	margin-top: 20px;
`

type Props = {
	toolName: string
	title: string
	onSeeInRecaps?: () => void
}

/**
 * An activity the group already did on an earlier day. Same copy as the
 * desktop `ArchivedActivityCard`, laid out as a phone card.
 */
export const ArchivedActivityView = ({
	toolName,
	title,
	onSeeInRecaps,
}: Props): JSX.Element => (
	<Screen data-testid="in_person.mobile.archived">
		<Eyebrow>{toolName}</Eyebrow>
		<Card>
			<CardLabel>
				<intl.Translate>script.archived.eyebrow</intl.Translate>
			</CardLabel>
			<CardTitle>{title}</CardTitle>
			<CardText>
				<intl.Translate>script.archived.description.participant</intl.Translate>
			</CardText>
		</Card>
		{onSeeInRecaps ? (
			<Actions>
				<Action secondary onClick={onSeeInRecaps}>
					<intl.Translate>script.archived.cta.see_in_recaps</intl.Translate>
				</Action>
			</Actions>
		) : null}
	</Screen>
)

export default ArchivedActivityView
